/**
 * Intro Block.
 * 
 */

/**
 * Mobile: 1-slide content slider sync'd with 1-slide photo slider. Dot nav adapted to display slide label.
 * Desktop: Same as mobile.
 */

// Set up slick slider for content slides.
let 
	$window = $(window),
	sliderBreakpoint = 1024,

	$myPhotoSlider = $('.intro-block__photo-slides'),
    myPhotoSliderSettings = {
        adaptiveHeight:false,
		arrows:false,
		// centerMode:true,
		dots: false,
		fade: true,
		infinite: true,
        mobileFirst:true,
        slidesToShow:1,
        slidesToScroll:1,
		speed:300,
		swipe:false,
        swipeToSlide:false,
		variableWidth:false,
        responsive: [
			{
				// breakpoint: 1023,
				// settings: 'unslick'
			}
        ]
    },

	$myContentSlider = $('.intro-block__content-slides'),
    myContentSliderSettings = {
        adaptiveHeight:true,
		arrows:false,
		asNavFor: $myPhotoSlider,
		// centerMode:true,
		dots: true,
		appendDots: $('.intro-block__dot-nav'),
		fade: true,
		infinite: true,
        mobileFirst:true,
        slidesToShow:1,
        slidesToScroll:1,
		speed:300,
        swipeToSlide:true,
		variableWidth:false,
        responsive: [
			{
				breakpoint: 1023,
				settings: {
					adaptiveHeight:false
				}
			}
        ]
    };

function initSlider() {
    // console.log('INTRO: initSlider()');
	$myContentSlider.on('init', function(event, slick){
		var $myDots = $( '.slick-dots li' );
		$myDots.each( function( k, v){
		  $(this).find('button').addClass( 'tab label'+ k );
		});
		var $mySlides = slick.$slides;
		$mySlides.each( function( k, v){
			var text = $(this).find('.intro-block__content-slide').data('label');
			$( '.tab.label' + k ).text(text);
		});
	});

	$myContentSlider.on('breakpoint', function(event, slick){
		var $myDots = $( '.slick-dots li' );
		$myDots.each( function( k, v){
		  $(this).find('button').addClass( 'tab label'+ k );
		});
		var $mySlides = slick.$slides;
		$mySlides.each( function( k, v){
			var text = $(this).find('.intro-block__content-slide').data('label');
			$( '.tab.label' + k ).text(text);
		});
	});

	$myPhotoSlider.slick(myPhotoSliderSettings);
	$myContentSlider.slick(myContentSliderSettings);
}

function replaceDotNav() {
    // console.log('INTRO: replaceDotNav()');
	var $myDots = $( '.slick-dots li' );
	$myDots.each( function( k, v){
		$(this).find('button').addClass( 'tab label'+ k );
	});
	var $mySlides = $('.intro-block__content-slide');
	$mySlides.each( function( k, v){
		var text = $(this).data('label');
		$( '.tab.label' + k ).text(text);
	});
}

let
	prevWindowW = $window.width(),
	currWindowW = prevWindowW;

// function initResizeWatcher() {
// 	// console.log('MISSION: initResizeWatcher()');
// 	$window.on('resize', function() {
// 		currWindowW = $window.width();
// 		// console.log('INTRO: WINDOW RESIZED: '+currWindowW+': '+prevWindowW);
// 		// Viewport width crosses from mobile to desktop.
// 		if ((currWindowW >= sliderBreakpoint) && (prevWindowW < sliderBreakpoint)) {
// 			console.log('INTRO: WINDOW RESIZED: mobile to desktop');
// 			replaceDotNav();
// 		}
// 		// Viewport width crosses from desktop to mobile.
// 		if ((currWindowW < sliderBreakpoint) && (prevWindowW >= sliderBreakpoint)) {
// 			console.log('INTRO: WINDOW RESIZED: desktop to mobile');
// 			replaceDotNav();		
// 		}
// 		prevWindowW = $window.width();
// 	});
// }

exports.init = function () {
	// console.log('MISSION: exports.init');
    // Run init methods...

	initSlider();
	// initResizeWatcher();
};